<script>
    import { onMount } from 'svelte';
    import Dialog from '/srv/web/wyvr/html/releases/58819/gen/client/shop/cart/Dialog.svelte?1733898724779';
    import { load_product } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/api-client/product/load_product.js?1733898724779';
    import Attribute from '/srv/web/wyvr/html/releases/58819/gen/client/shop/cart/Attribute.svelte?1733898724779';
    import { get_attribute_name, get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724779';
    import Image from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Image.svelte?1733898724779';
    import ImageAttribute from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/ImageAttribute.svelte?1733898724779';
    import Price from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Price.svelte?1733898724779';
    import { checkout_entrance } from '/srv/web/wyvr/html/releases/58819/gen/client/checkout/logic/actions.js?1733898724779';
    import Recommendations from '/srv/web/wyvr/html/releases/58819/gen/client/recommendations/Recommendations.svelte?1733898724779';
    import CrossellSlider from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/CrossellSlider.svelte?1733898724779';
    import { logger } from '@wyvr/generator/universal.js';

    wyvr: {
        render: 'hydrate';
        loading: 'instant';
    }

    let product;
    let brand;
    let locale = getStack('locale');
    let currency = getStack('currency');

    const attribute_codes = [
        {
            attribute: 'kw_main_color',
            fallback: 'color'
        },

        { attribute: 'kw_volume', unit: 'l', transform: 'number' },

        'kw_material_new'
    ];
    let open = false;
    let title;

    onMount(() => {
        on('cart.add', async ({ qty, prev_qty, item }) => {
            if (!prev_qty && item.sku) {
                title = `<i class="ri-check-line"></i> <span>${window.__('cart_popup.title')}</span>`;
                const [error, loaded_product] = await load_product(item.sku);
                if (error) {
                    logger.error('could not load product', sku, error);
                    return;
                }
                product = loaded_product;
                brand = get_attribute_name(product, 'pim_brand');

                setTimeout(() => {
                    open = true;
                }, 10);
            }
        });
    });
    function cart() {
        checkout_entrance('cart');
    }
    function close() {
        open = false;
        product = undefined;
    }
</script>

{#if product && true}
    <Dialog bind:open {title} cssClass={'cart-message'}>
        <div class="content">
            <div class="img product-image">
                {#if product.image}
                    <ImageAttribute {product} name="thumbnail" width={150} height={150} />
                {:else if product.thumbnail}
                    <Image src={get_attribute_value(product, 'thumbnail')} width={150} height={150} alt={get_attribute_value(product, 'name')} />
                {/if}
            </div>
            <div class="product">
                <h3 class="name">{@html get_attribute_value(product, 'name')}</h3>
                {#if brand}
                    <h4 class="brand">{brand}</h4>
                {/if}
                <div class="product-details">
                    {#each attribute_codes as attribute}
                        <Attribute {product} {attribute} />
                    {/each}
                    <div class="label">{window.__('cart.price')}</div>
                    <Price {product} force_price_display={true} {locale} {currency} />
                </div>
            </div>
        </div>
        <div class="actions">
            <button class="btn" on:click={close}>{window.__('cart_popup.continue')}</button>
            <button class="btn btn--green" on:click={cart}>{window.__('cart_popup.cart')}</button>
        </div>

        <div class="m-product-crosssell-slider">
            <CrossellSlider products={product.cross_sell_products} title={window.__('recommendations.crossell')} />
        </div>
    </Dialog>
{/if}


<style>
    :global(.c-dialog-wrapper.cart-message header.dialog-header) {
        padding: 0 !important;
        border-bottom: none !important;
    }

    :global(.cart-message header > section) {
        color: var(--green);
    }

    .label {
        font-weight: 800;
    }

    .product-details :global(.m-product-price__price-box) {
        align-items: flex-start !important;
        flex-direction: column !important;
    }

    .product-details :global(.price--new) {
        font-size: 0.875rem !important;
        font-weight: 400 !important;
        line-height: 1.8 !important;
        color: #303133 !important;
    }

    .product-details :global(.price) {
        font-size: 0.875rem !important;
        font-weight: 400 !important;
        line-height: 1.8 !important;
        color: #303133 !important;
    }

    .product-details :global(.old-price) {
        flex-direction: row !important;
        align-items: flex-end;
        gap: 5px !important;
        margin-left: 0px !important;
        align-items: center;
    }

    .product-details :global(.price--uvp) {
        font-weight: 800 !important;
        line-height: 1.8 !important;
        font-size: 0.875rem !important;
    }

    .product-details :global(.price.price--old) {
        font-size: 0.875rem !important;
        font-weight: 400 !important;
        line-height: 1.8 !important;
    }

    .product-details {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        width: 100%;
        font-size: var(--font-size__xs);
    }

    .product-details > :global(div:not(.value, .label, .m-product-price__price-box)) {
        grid-column-start: 1;
        grid-column-end: -1;
    }

    .product-details :global(ul) {
        padding-left: 1rem;
    }

    .content {
        display: -ms-grid;
        display: grid;
        -ms-grid-columns: 1fr;
        grid-template-columns: 1fr;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        justify-items: center;
        grid-gap: 15px;
        margin-top: 15px;
    }

    :global(.c-dialog-wrapper.cart-message .content) {
        padding-bottom: 0;
    }

    .img {
        width: 100%;
        min-width: 150px;
        -ms-grid-column-align: right;
        justify-self: right;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
    }

    .product {
        -ms-grid-column-align: left;
        justify-self: left;
    }

    .name {
        margin-bottom: 0;
    }

    .brand {
        margin-bottom: 10px;
    }

    .actions {
        display: -ms-grid;
        display: grid;
        -ms-grid-columns: (1fr) [2];
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 10px;
        max-width: 100%;
        padding: 15px 0 30px 0;
        margin: 0 auto;
    }

    @media (min-width: 480px) {
        .content {
            -ms-grid-columns: 1fr 1fr;
            grid-template-columns: 1fr 1fr;
            grid-gap: 30px;
        }
        .img {
            max-width: 200px;
            -webkit-box-pack: end;
            -ms-flex-pack: end;
            justify-content: flex-end;
        }
        .actions {
            max-width: 60%;
        }
    }

    :global(.cart-message .m-product-crosssell-slider .h2.m-product-list__brand-name) {
        @media (min-width: 992px) {
            font-size: var(--h3__font-size-desktop);
            hyphens: auto;
        }
    }

    :global(.cart-message .m-product-crosssell-slider .m-product-list__name) {
        @media (min-width: 992px) {
            font-size: var(--h4__font-size-desktop);
        }
    }

    :global(.cart-message .m-product-crosssell-slider .product .price) {
        @media (min-width: 992px) {
            font-size: var(--h4__font-size-desktop);
        }
    }
</style>